import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { useState, useRefm, useEffect } from 'react';
import {isMobileOnly} from 'react-device-detect';
import TagBtnMy from '../../components/common/button/TagBtnMy';
import { remove, uniq, filter, forEach, findIndex } from 'lodash';
import { setEsMyBrandCate1StepAction } from '../../modules/es/esMyModule';

const MyEs2CateItemBlock = styled.div`
    display: ${props => props.display || 'none'};

`;

const MyEsCategoryBlock = styled.div`
    //display: ${props => props.display || 'none'};
    
    ${isMobileOnly?`
    width: 92vw;
    margin-bottom: 10px;
    `:`
    width: 100%;
    margin-bottom: 40px;
    `};
    
    position: relative;
    ${isMobileOnly&&`
        .tf-list {
            display:flex;
            flex-wrap:wrap;
            align-items: flex-start;
        }      
    `};
    .tf-list {
        display:flex;
        flex-wrap:wrap;
        align-items: flex-start;
    }  
`;

const MyEs2CateItem = ({category=null, active=false}) => {
    
    const dispatch = useDispatch();
    const [allChecked, setAllChecked] = useState(false);
    const itemMargin = isMobileOnly?{marginRight: '6px', marginBottom: '10px'}:{marginRight: '6px', marginBottom: '0px', marginTop: '5px'};

    const { esMyBrandCate1Step } = useSelector(
        ({ esMyReducer }) => ({
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,

        })
    );

    useEffect(() => {
        if(esMyBrandCate1Step && category && category.cate2) {
            let all = true;
            //console.log("esMyBrandCate1Step = " + JSON.stringify(esMyBrandCate1Step))
            for(let i = 0; i < category.cate2.length ; i++) {
                let objIdx = findIndex(esMyBrandCate1Step, (obj) => {
                    const cateid = (category.id * 100) + category.cate2[i].id;
                    return (obj === cateid);
                })

                if(objIdx < 0) {
                    all = false;
                    break;
                }
            }
            setAllChecked(all);
        }
        
    }, [esMyBrandCate1Step, category]);
    
    const handleCateClick = (cateid) => {
        let cate = [];
        Object.assign(cate, esMyBrandCate1Step);
        //console.log("cateid = " + JSON.stringify(cateid))
        if(allChecked) {
            forEach(category.cate2, (curobj, index) => {
                const cateid = (category.id * 100) + curobj.id;
                
                remove(cate, (obj) => {
                    return (obj === cateid);
                });
            });

            cate.push(cateid);
            //console.log("cate = " + JSON.stringify(cate))
            dispatch(setEsMyBrandCate1StepAction(cate));
        } else {
            let objIdx = findIndex(cate, (obj) => {
                return (obj === cateid);
            })
    
            if(objIdx >= 0) {
                remove(cate, (obj) => {
                    return (obj === cateid);
                });
            } else {
                cate.push(cateid);
            }
        }

        //console.log("cate = " + JSON.stringify(cate))
        dispatch(setEsMyBrandCate1StepAction(cate));
    }

    const handleAllCheckClick = () => {
        let cate = [];
        Object.assign(cate, esMyBrandCate1Step);
        
        if(allChecked) {
            forEach(category.cate2, (curobj, index) => {
                const cateid = (category.id * 100) + curobj.id;
                
                remove(cate, (obj) => {
                    return (obj === cateid);
                });
            });

            //console.log("cate = " + JSON.stringify(cate))
            dispatch(setEsMyBrandCate1StepAction(cate));
        } else {
            setAllChecked(true);
            forEach(category.cate2, (curobj, index) => {
                const cateid = (category.id * 100) + curobj.id;
                cate.push(cateid);
            });
            //console.log("cate before = " + JSON.stringify(cate));
            cate = uniq(cate)
            //console.log("cate after = " + JSON.stringify(cate));
            dispatch(setEsMyBrandCate1StepAction(cate));
        }
    }

    const checkActive = (cateid) => {
        if(allChecked) {
            return false;
        }

        let objIdx = findIndex(esMyBrandCate1Step, (obj) => {
            return (obj === cateid);
        })

        if(objIdx >= 0) {
            return true;
        } 

        return false;
    }

    if(active === false || category === null) {
       return  <MyEs2CateItemBlock display={"none"} />
    }

    return (
        <MyEs2CateItemBlock display={active? "block;":"none"}>
            
            <MyEsCategoryBlock>
                <ul className="tf-list clearfix">
                    <li style={ isMobileOnly? {marginRight:'6px'}:{marginRight:'6px', marginTop: '5px'}}>
                        <TagBtnMy active={allChecked}
                            float='left' onClick={handleAllCheckClick}
                            onDelClick={handleAllCheckClick}
                            text='전체' isSmall={true} value={false}
                            noDelBtn={true}
                        />
                    </li>
                    {
                        category.cate2.map((cateitem) => {
                            const cateid = (category.id * 100) + cateitem.id;
                            const name = cateitem.cate_name;
                            return (
                                <li key={cateid} style={itemMargin}>
                                    <TagBtnMy
                                        active={checkActive(cateid)}
                                        float='left'
                                        onClick={handleCateClick}
                                        onDelClick={handleCateClick}
                                        text={name} isSmall={true} value={cateid}
                                        noDelBtn={true}
                                    />
                                </li>
                            );
                        })
                    }
                </ul>
            </MyEsCategoryBlock>
        </MyEs2CateItemBlock>
    );
};

export default MyEs2CateItem;